function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMyWishlist = function SvgMyWishlist(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1024 1024"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M700.9 122.5c-71.5 0-138.6 29-191.7 82.3-44.7-50.8-114.1-82.3-185-82.3-140.8 0-259.6 118.9-259.6 259.6C64.6 626 346.5 845.6 504.3 900c2.7.9 5.5 1.4 8.3 1.4s5.6-.5 8.3-1.4c157.8-54.4 439.7-274 439.7-517.9-.1-140.7-119-259.6-259.7-259.6M512.5 849c-143.2-53.6-397.1-254.3-397.1-466.8 0-113.2 95.6-208.7 208.7-208.7 64.4 0 129.5 34.1 161.8 85 4.4 6.9 11.8 11.3 20 11.7 8 .4 16.1-3 21.2-9.3 46.1-56.3 107.8-87.4 173.8-87.4 113.2 0 208.7 95.6 208.7 208.7-.1 212.5-253.9 413.1-397.1 466.8",
    style: {
      fill: "#666"
    }
  }));
};
export default SvgMyWishlist;